import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { Router } from '@angular/router';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';
import { EmployeeData, UserData } from 'src/app/Models/employee-and-user-data';
import * as moment from 'moment';
import { TripContextService } from 'src/app/Services/trip-context.service';

@Component({
  selector: 'app-pci-page',
  templateUrl: './pci-page.component.html',
  styleUrls: ['./pci-page.component.css'],
})
export class PCIPageComponent implements OnInit {
  imagepath = '';
  validsession: boolean | undefined;
  userdata?: UserData;
  LoginData: any;
  employeeData?: EmployeeData;
  shpId: number | undefined;

  currentdate: string | undefined;
  CurrentTime: string | undefined;
  pagemask: boolean | undefined; 

  
  constructor(
    private appConfigService: AppConfigService,
    private sesssionvalidator: SessionvalidateService,
    private router: Router,
    private EmployeeLoginService: EmployeeloginService,
    private tripContextService: TripContextService
  ) {
    // this.validsession = this.sesssionvalidator.validate();
    // if (this.validsession) {
    // } else {
    //   this.router.navigate(['/login']);
    // }
  }

  ngOnInit(): void {
    this.imagepath = this.appConfigService.imagepath;
    this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');
    if (this.employeeData?.EmployeeNo != undefined) {
      this.checkLogin();
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
      } else {
        this.router.navigate(['/login']);
      }
    }

    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');

    this.pagemask = this.tripContextService.resolve(this.userdata).pagemask;
  }

  checkLogin() {
    this.LoginData = this.EmployeeLoginService.GetEmployeeLogin(
      this.employeeData?.EmployeeNo,
      this.employeeData?.LastName
    ).subscribe((LoginData) => this.setCheckLogin(LoginData));
  }

  setCheckLogin(resdata: any) {
    this.LoginData = resdata;
    if (this.LoginData.GetEmployeeLogin.Result.Status != 'A') {
      this.router.navigate(['/adminlogin']);
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
      } else {
        this.router.navigate(['/shipselect']);
      }
    }
  }
}
